import { lang } from "../utils/Lang";

const LANG_MAP = { pl: 'pl_PL', de: 'de_DE', cz: 'cs_CZ' };
const CURRENCY_MAP = { pl: 'PLN', de: 'EUR', cz: 'CZK' };
function getLangCode() { return LANG_MAP[lang.current] || 'pl_PL'; }
function getCurrency() { return CURRENCY_MAP[lang.current] || 'PLN'; }

/**
 * Reads an error from a frontAPI callback response without throwing. The API
 * may return either `_flash_messenger.error` or a plain `{ error_description }`
 * / `{ error }` object (e.g. on a 404), so accessing `_flash_messenger.error`
 * directly can crash inside the XHR callback where no try/catch can help.
 */
function getApiError(response) {
    const messenger = response?._flash_messenger?.error;
    if (Array.isArray(messenger) && messenger.length > 0) {
        return messenger;
    }
    if (response?.error_description) {
        return response.error_description;
    }
    if (response?.error) {
        return response.error;
    }
    return null;
}

/**
 * Adapter for Shoper frontAPI (window.frontAPI).
 * Will be replaced by StorefrontAdapter in the future.
 */
export default class FrontAPIAdapter {
    errorDemoMode = false;

    setErrorDemoMode(bool) {
        this.errorDemoMode = !!bool;
    }

    addToBasket(data) {
        let requestData = data;
        if (this.errorDemoMode) {
            console.log('[FrontAPIAdapter] errorDemoMode using wrong stock_id', data);
            requestData = { ...data, stock_id: 9999999 };
        }
        return new Promise((resolve, reject) => {
            frontAPI.addToBasket(function (addInfo) {
                console.log(addInfo);
                const error = getApiError(addInfo);
                if (error) {
                    reject(error);
                } else {
                    resolve(addInfo?.added);
                }
            }, {
                lang: getLangCode(),
                currency: getCurrency(),
                data: requestData
            });
        });
    }

    removeFromBasket(id) {
        return new Promise((resolve, reject) => {
            frontAPI.removeFromBasket(function (addInfo) {
                console.log(addInfo);
                const error = getApiError(addInfo);
                if (error) {
                    reject(error);
                } else {
                    resolve(addInfo?.added);
                }
            }, {
                lang: getLangCode(),
                currency: getCurrency(),
                id
            });
        });
    }

    getBasket() {
        return new Promise((resolve, reject) => {
            frontAPI.getBasketInfo(function (cart) {
                console.log(cart);
                const error = getApiError(cart);
                if (error) {
                    reject(error);
                    return;
                }
                resolve(cart);
            }, {
                lang: getLangCode(),
                currency: getCurrency()
            });
        });
    }

    getProduct(id) {
        return new Promise((resolve, reject) => {
            frontAPI.getProduct(function (product) {
                console.log(product);
                resolve(product);
            }, {
                lang: getLangCode(),
                currency: getCurrency(),
                id
            });
        });
    }
}
